import { render } from "./ProductLinesView.vue?vue&type=template&id=42573cf1"
import script from "./ProductLinesView.vue?vue&type=script&lang=js"
export * from "./ProductLinesView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__